export const costs = [
  'Sleepless nights searching for ways to translate complex mineral processing concepts into language your students can understand.',
  "Improvised classes because you couldn't find clear, ready-to-use materials in time.",
  "Disconnected students who don't see how mineral processing connects to their futures, careers, or real-world mining operations.",
  "Awkward silences when a student asks about flotation chemistry or process optimization and you don't have a clear answer.",
  'Weekends lost building lesson plans, mineral processing projects, and assessments from scratch over and over.',
  'Uncertainty about how to teach comminution, separation, flotation, plant operations, safety, or troubleshooting without adequate resources.',
];
